'use strict';

var util = require('./property-util');
var arrayUtil = require('./array-util');

module.exports = {
    convertPoolId: function (pools, id, projectId) {
        var found = arrayUtil.getFirstInList(pools, 'id', id);

        if (!util.isDefined(found)) {
            return "Unpooled";
        } else {
            if(util.isDefined(projectId) && found.projectId != projectId){
                return undefined;
            }
            return found.name;
        }
    },

    getSimClass: function (priority) {
        var classes = ['light', 'success', 'warning', 'danger'];
        return classes[priority];
    },

    getSimColor: function (priority) {
        var colors = ['white', '#5cb85c', '#FFE421', '#EA3636'];
        return colors[priority];
    }
};


